import React from 'react';
import { useHistory } from 'react-router-dom';
import css from './CTACardsSection.module.css';
import Button from '../Button/Button';
import SportsMMAIcon from '../Icons/SportsMMAIcon';
import MartialArtsIcon from '../Icons/MartialArtsIcon';

const CTACardsSection = () => {
  const history = useHistory();

  return (
    <div className={css.section}>
      <div className={css.cardsContainer}>
        <div className={css.card}>
          <div className={css.cardContent}>
            <div className={css.cardHeader}>
              <SportsMMAIcon className={css.icon} color="black" />
              <div className={css.cardTitle}>Sell Your Gear</div>
            </div>

            <p className={css.cardDescription}>
              Turn your martial arts equipment into cash. Easy listing, secure
              transactions,
            </p>

            <Button
              className={css.cardButton}
              variant="primary"
              text="List your gear"
              onClick={() => history.push('/l/new')}
            />
          </div>
        </div>

        <div className={css.card}>
          <div className={css.cardContent}>
            <div className={css.cardHeader}>
              <MartialArtsIcon className={css.icon} color="black" />
              <div className={css.cardTitle}>Gym Owners</div>
            </div>

            <p className={css.cardDescription}>
              Get discovered by new students. Add your gym to our directory
              and grow your community.
            </p>

            <Button
              className={css.cardButton}
              variant="secondary"
              text="Add your gym"
              onClick={() => {
                if (typeof window !== 'undefined') {
                  window.open('https://docs.google.com/forms/d/1-2UiuPWtuS1yn5BnrvI4du2-4I8B6xoFQP9O2OV-yGY/edit', '_blank', 'noopener,noreferrer');
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTACardsSection;

